import React, { useEffect } from 'react';
import { IItemForGetShortInfo, IItemForGetShortDishInfo, IGetDishesShort } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getDishesShortBySubCategoryIdV2 } from 'backend/dishes';
import { MultipleSelect } from './MultipleSelect';
import style from './index.module.scss';

interface IProps {
	setFetchedAdditionalDishSubCategories: (value: IItemForGetShortInfo[]) => void;
	setFetchedAdditionalDishes: (value: IItemForGetShortInfo[]) => void;
	setAdditionalDishCategory: (value: Nullable<string>) => void;
	setAdditionalDishSubCategory: (value: Nullable<string>) => void;
	setAdditionalDishes: (value: string[]) => void;
	removeAdditionalDish: (value: string) => void;
	IDsSelectedRestaurant: string[];
	selectedAdditionalDishCategory: Nullable<string>;
	selectedAdditionalDishSubCategory: Nullable<string>;
	fetchedAdditionalDishes: IItemForGetShortDishInfo[];
	selectedAdditionalDishes: string[];
}

export const AdditionalDishMultipleSelect: React.FC<IProps> = React.memo(
	({
		setFetchedAdditionalDishSubCategories,
		setFetchedAdditionalDishes,
		setAdditionalDishCategory,
		setAdditionalDishSubCategory,
		setAdditionalDishes,
		removeAdditionalDish,
		IDsSelectedRestaurant,
		selectedAdditionalDishCategory,
		selectedAdditionalDishSubCategory,
		fetchedAdditionalDishes,
		selectedAdditionalDishes,
	}) => {
		const { response, loading, refetch, responseError } = useFetchData<IGetDishesShort, string>(
			selectedAdditionalDishSubCategory ? getDishesShortBySubCategoryIdV2 : null,
			selectedAdditionalDishSubCategory || '',
		);

		useEffect(() => {
			refetch();
		}, [selectedAdditionalDishSubCategory]);

		useEffect(() => {
			if (response) {
				setFetchedAdditionalDishes(response.data.dishes);
			}
		}, [response]);

		return (
			<div className={style.container}>
				<div className={style.field}>
					<MultipleSelect
						refetch={refetch}
						setFetchedAdditionalDishSubCategories={setFetchedAdditionalDishSubCategories}
						setAdditionalDishCategory={setAdditionalDishCategory}
						setAdditionalDishSubCategory={setAdditionalDishSubCategory}
						setAdditionalDishes={setAdditionalDishes}
						removeAdditionalDish={removeAdditionalDish}
						data={
							selectedAdditionalDishSubCategory && response?.data.dishes && !loading
								? response.data.dishes
								: []
						}
						IDsSelectedRestaurant={IDsSelectedRestaurant}
						selectedAdditionalDishCategory={selectedAdditionalDishCategory}
						selectedAdditionalDishSubCategory={selectedAdditionalDishSubCategory}
						fetchedAdditionalDishes={fetchedAdditionalDishes}
						selectedAdditionalDishes={selectedAdditionalDishes}
						isLoading={loading}
						responseError={responseError}
					/>
				</div>
			</div>
		);
	},
);
